import React, {
  FC, useCallback, useState,
} from 'react';

import classNames from 'classnames';

import {
  HorizontalBannerWidgetZone,
} from '@app/common/components/HorizontalBannerWidgetZone/HorizontalBannerWidgetZone';

import { ZoneName } from '@app/core/components/WidgetZone/constants';

import twinLayoutStyles from '../TwinColumnLayout.pcss';

import styles from './TwinColumnLayoutHorizontalZone.pcss';

/**
 * Main layout component properties
 */
export interface TwinColumnLayoutHorizontalZoneProps {
  readonly className?: string;
  readonly zoneName: ZoneName.HeaderBanner | ZoneName.FooterBanner | ZoneName.PostMiddle | ZoneName.PreMiddle;
}

/**
 * Horizontal ads zone to be placed inside page above and below TwinColumnLayout.
 * NOTE: zone background should reflect same areas as TwinColumnLayout, so
 * we reuse many styles from TwinColumnLayout component.
 */
// eslint-disable-next-line import/prefer-default-export
export const TwinColumnLayoutHorizontalZone:FC<TwinColumnLayoutHorizontalZoneProps> = (
  { className, zoneName },
) => {
  const [isEmpty, setEmpty] = useState<Boolean>(true);
  const onRenderWidgetsInner = useCallback((widgetCount:number) => {
    setEmpty(widgetCount === 0);
  }, [zoneName]);
  return (
    <div
      className={classNames(
        className,
        styles.bannerContainer,
        isEmpty && styles.empty,
      )}
    >
      <div className={classNames(styles.row, styles.bannerInner)}>
        <div className={classNames(twinLayoutStyles.leftPadding)} />
        <div
          className={classNames(
            styles.centerContainer,
            twinLayoutStyles.centerContainer,
          )}
        >
          <div className={classNames(styles.bannerBackground)}>
            <section className={classNames(twinLayoutStyles.selector)} />
            <section className={classNames(twinLayoutStyles.content)} />
          </div>
        </div>
        {zoneName !== ZoneName.PostMiddle
          && zoneName !== ZoneName.PreMiddle && (
            <div className={classNames(styles.rightBannerShift)} />
        )}
        {/* make a shift from right side by width of right banner widget to match background */}
        <div className={classNames(twinLayoutStyles.rightPadding)} />
      </div>
      <HorizontalBannerWidgetZone
        className={classNames(styles.bannerInner)}
        zoneName={zoneName}
        onRenderWidgets={onRenderWidgetsInner}
      />
    </div>
  );
};
